import { Application } from '@splinetool/runtime';

const canvas = document.getElementById('canvas3d') as HTMLCanvasElement;
const app = new Application(canvas);
app.load('https://prod.spline.design/URN4k-jWhIGO3C7J/scene.splinecode');


// Select the header element
const header = document.getElementById('navbar');
const year = document.getElementById('year');
const dataContainers = document.getElementsByClassName('data-obfuscate');

// Set the current year
year.textContent = new Date().getFullYear().toString();

// Function to handle scroll event
function onScroll() {
  if (window.scrollY > 50) {
    header.classList.add('shadow-lg');
    header.classList.remove('bg-transparent');
  } else {
    header.classList.add('bg-transparent');
    header.classList.remove('shadow-lg');
  }
}

// Attach the scroll event listener to the window
window.addEventListener('scroll', onScroll);
window.addEventListener('load', onScroll);


// Obfuscate email addresses
for (let i = 0; i < dataContainers.length; i++) {
  const e = dataContainers[i];
  const base64 = e.getAttribute('data-obfuscate');
  const data = atob(base64);
  const replace = e.getAttribute('data-replace') || false;
  // check if element is an anchor tag
  if (e.tagName === 'A') {
    e.setAttribute('href', `mailto:${data}`);
  }

  if (replace) {
    e.textContent = data;
  }
}


// Load top Dev.to articles into the Writing section
type DevtoArticle = {
  title: string;
  url: string;
  description: string;
  public_reactions_count: number;
  reading_time_minutes: number;
};

function escapeHtml(s: string): string {
  const div = document.createElement('div');
  div.textContent = s;
  return div.innerHTML;
}

async function loadWriting() {
  const container = document.getElementById('writing-list');
  if (!container) return;

  try {
    const res = await fetch('https://dev.to/api/articles?username=sudo_blaze&top=365');
    if (!res.ok) throw new Error(`status ${res.status}`);
    const articles: DevtoArticle[] = await res.json();
    const top3 = articles
      .sort((a, b) => b.public_reactions_count - a.public_reactions_count)
      .slice(0, 3);

    if (top3.length === 0) throw new Error('no articles');

    container.innerHTML = top3.map(a => `
      <a href="${escapeHtml(a.url)}" target="_blank" rel="noopener noreferrer" class="group bg-white border border-white rounded-lg p-6 hover:border-purple-700 hover:shadow-[0_0_20px_rgba(126,34,206,0.35)] transition flex flex-col">
        <h3 class="text-lg font-bold text-gray-900 group-hover:text-purple-700 chakra-petch-bold">${escapeHtml(a.title)}</h3>
        <p class="mt-2 text-sm text-gray-600 flex-grow">${escapeHtml(a.description)}</p>
        <div class="mt-4 flex items-center justify-between text-xs text-gray-500">
          <span>&#9829; ${a.public_reactions_count} &middot; ${a.reading_time_minutes} min read</span>
          <span class="text-purple-500">Read &rarr;</span>
        </div>
      </a>
    `).join('');
  } catch (err) {
    container.innerHTML = `<p class="col-span-full text-center text-gray-500">Posts available at <a class="text-purple-500" href="https://dev.to/sudo_blaze" target="_blank" rel="noopener noreferrer">dev.to/sudo_blaze</a>.</p>`;
  }
}

loadWriting();